import { Plus } from '@lucide/vue';
import type { CommandFactory } from './commands';
import { appLocationCommand } from './appCommand';

/**
 * The dashboard app's palette entry (I-2348): a new dashboard, the same unsaved
 * draft the list's „Neues Dashboard“ opens. Starting from a template joins the
 * palette on the list (frontend/dashboard).
 */
export const dashboardCommands: CommandFactory = ({ router, t, appLabel: dashboard }) => [
  appLocationCommand(router, {
    id: 'dashboard.new',
    app: 'dashboard',
    group: dashboard,
    label: `${dashboard}: ${t('dashboard.create')}`,
    href: '/dashboard/new',
    icon: Plus,
    keywords: ['dashboard', 'cockpit', 'neu', 'new', 'anlegen'],
  }),
];
